module.exports = __webpack_public_path__ + "static/media/FAQ-bilingual.a9bc339f.svg";